import React from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import makeBem from "Utils/makeBem";

const bem = makeBem("ColoredDot");

const ColoredDot = ({ value, mean, stdev, color }) => {
  const shouldCalculateColor = [mean, stdev, value].every((v) => typeof v === "number");
  const colorValue = shouldCalculateColor ? getDotColor(value, mean, stdev) : color;
  return <div className={classnames(bem(), bem(null, colorValue))} />;
};

const getDotColor = (value, mean, stdev) => {
  if (value == 0) return "green";
  const distance = (value - mean) / stdev;
  return distance > 0.5 ? "orange" : distance < -0.5 ? "green" : "yellow";
};

ColoredDot.propTypes = {
  value: PropTypes.number,
  mean: PropTypes.number,
  stdev: PropTypes.number,
  color: PropTypes.string,
};
export default ColoredDot;
